import { render, staticRenderFns } from "./OperaWithdrawDetailWindow.vue?vue&type=template&id=fd6bc970&scoped=true&"
import script from "./OperaWithdrawDetailWindow.vue?vue&type=script&lang=js&"
export * from "./OperaWithdrawDetailWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaWithdrawDetailWindow.vue?vue&type=style&index=0&id=fd6bc970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6bc970",
  null
  
)

export default component.exports